import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalHeader,
  Button,
  Text,
  VStack,
  HStack,
  Box,
} from "@chakra-ui/react";
import { GaraazInput } from "@svan-garaaz/reactsharedlib";

type AddReturnAmountModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (returnAmount: number) => Promise<void>;
  returnAmountOrderInvoiceInfo: any;
  validateReturnAmountToAdd: (returnAmountToAdd: number) => string | null;
};

const AddReturnAmountModal: React.FC<AddReturnAmountModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  returnAmountOrderInvoiceInfo,
  validateReturnAmountToAdd,
}) => {
  const [returnAmountToAdd, setReturnAmountToAdd] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleAmountChange = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
    setReturnAmountToAdd(event.target.value);
    const numValue = Number(event.target.value);
    setError(validateReturnAmountToAdd(numValue));
  };

  const handleConfirm = async () => {
    try {
      setIsSubmitting(true);
      await onSubmit(Number(returnAmountToAdd));
    } catch (error) {}
    finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Return Amount</ModalHeader>
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Box>
              <Text fontSize="sm" color="gray.600">
                Invoice Amount : ₹{returnAmountOrderInvoiceInfo.invoiceAmount}
              </Text>
              <Text fontSize="sm" color="gray.600">
                Current Return Amount : ₹{returnAmountOrderInvoiceInfo.returnAmount || 0}
              </Text>
              {!error && returnAmountToAdd !== "" && Number(returnAmountToAdd)!==0 && (
              <Text fontSize="sm" color="gray.600">
                New Total Return Amount : ₹{(returnAmountOrderInvoiceInfo.returnAmount || 0) + Number(returnAmountToAdd)}
              </Text>     
              )}
            </Box>
            <Box>
              <GaraazInput
                width="100%"
                inputName="returnAmount"
                label=""
                value={returnAmountToAdd}
                placeholder="Enter return amount to add"
                inputType="number"
                onChange={handleAmountChange}
                isRequired={false}
              />
              {error && (
                <Text fontSize="sm" color="red.500" mt={2}>{error}</Text>
              )}
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <Button variant="outline" onClick={onClose} isDisabled={isSubmitting}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleConfirm}
              isDisabled={!!error || returnAmountToAdd === "" || Number(returnAmountToAdd)===0}
              isLoading={isSubmitting}
            >
              Confirm
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddReturnAmountModal;
